import React from 'react'
import Sidebar from '../Sidebar'
const Layout = (props) => {
    const {
        children,
        openmenu,
        closemenu,
        mobilemenu,
        main,
        user,
        logout,
        mobilemenumain
    } = props;


    return (
        <div className='Layout'>
            <div className='container-fluid' ref={main}>
                <div className='row'>
                    <div className='col-lg-3 d-none d-lg-block'>
                        <div className='sidebar'>
                            <div className='responsive-sidebar'>
                                <div className='title-web'>
                                    <p>پنل مدیریت</p>
                                </div>
                                <Sidebar logout={logout} user={user} />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-9 col-12'>
                        <div className='header'>
                            <div className='d-flex align-items-center'>
                                <div onClick={openmenu} className='menu-icon d-block d-lg-none'>
                                    <svg width="30" height="23" viewBox="0 0 30 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="28.5" y1="1.5" x2="16.5" y2="1.5" stroke="#666666" strokeWidth="3" strokeLinecap="round" />
                                        <line x1="28.5" y1="11.5" x2="11.5" y2="11.5" stroke="#666666" strokeWidth="3" strokeLinecap="round" />
                                        <line x1="28.5" y1="21.5" x2="1.5" y2="21.5" stroke="#666666" strokeWidth="3" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <span id='title-page'></span>
                            </div>
                        </div>
                        <div className='main-content'>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <div className='mobile-menu' ref={mobilemenu}>
                <div className='d-flex justify-content-between'>
                    <div className='main'>
                        <div className='sidebar' style={{ right: '-108%' }} ref={mobilemenumain}>
                            <div className='title-web'>
                                <p>پنل مدیریت</p>
                            </div>
                            <Sidebar logout={logout} user={user} />
                        </div>
                    </div>
                    <div className='p-3' onClick={() => closemenu()}>
                        <svg width={25} height={25} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M17.9175 0C22.1537 0 25 2.9725 25 7.395V17.605C25 22.0275 22.1538 25 17.9163 25H7.08125C2.845 25 0 22.0275 0 17.605V7.395C0 2.9725 2.845 0 7.08125 0H17.9175ZM17.9175 1.875H7.08125C3.91875 1.875 1.875 4.04125 1.875 7.395V17.605C1.875 20.9587 3.91875 23.125 7.08125 23.125H17.9163C21.08 23.125 23.125 20.9587 23.125 17.605V7.395C23.125 4.04125 21.08 1.875 17.9175 1.875ZM10.1631 8.82825L12.4975 11.1625L14.8306 8.83088C15.1969 8.46463 15.7894 8.46463 16.1556 8.83088C16.5219 9.19713 16.5219 9.78962 16.1556 10.1559L13.8225 12.4875L16.1581 14.8245C16.5244 15.1908 16.5244 15.7832 16.1581 16.1495C15.9756 16.3332 15.7344 16.4245 15.4956 16.4245C15.2556 16.4245 15.0156 16.3332 14.8331 16.1495L12.4975 13.8125L10.1656 16.1459C9.98312 16.3296 9.74312 16.4209 9.50312 16.4209C9.26312 16.4209 9.02313 16.3296 8.84063 16.1459C8.47438 15.7796 8.47438 15.1871 8.84063 14.8209L11.1725 12.4875L8.83812 10.1532C8.47187 9.787 8.47187 9.1945 8.83812 8.82825C9.20562 8.462 9.79812 8.462 10.1631 8.82825Z" fill="white" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout